import script from "./PropertyVisitPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./PropertyVisitPagination.vue?vue&type=script&lang=ts&setup=true"

import "./PropertyVisitPagination.vue?vue&type=style&index=0&id=732eab7e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-732eab7e"]])

export default __exports__